import request from '@/request'

export async function getUserUnreadNotificationCount() {
  return await request({
    url: `/users/me/notifications/unread/count`,
    method: 'get'
  })
}

export async function getUserNotifications({ page }) {
  return await request({
    url: `/users/me/notifications?page=${page}`,
    method: 'get'
  })
}

export async function markUserNotificationAsRead (notificationId) {
  return await request({
    url: `/users/me/notifications/${notificationId}`,
    method: 'post',
    data: {
      _method: 'put',
      read: 1
    }
  })
}